import { Component } from "react";
import Flow from "src/components/Flow";
import PopoverView from "src/components/PopoverView";

import HistoryActivityLog from "./HistoryActivityLog/HistoryActivityLog";
import ActivityLogDescription from "./ActivityLogDescription";

const steps = [
  {
    id: "activity-log",
    Component: ({ onClose, flow, flowState, setFlowState }) => (
      <HistoryActivityLog
        onClose={onClose}
        openDescription={flow.next}
        flowState={flowState}
        setFlowState={setFlowState}
      />
    )
  },
  {
    id: "activity-log-description",
    Component: ({ onClose, flow }) => (
      <ActivityLogDescription onClose={onClose} onBack={flow.previous} />
    )
  }
];

class HistoryActivityLogFlow extends Component {
  state = {
    monitorings: {},
    selectedMonitoringId: null,
    hasMoreMonitorings: false
  };

  componentDidMount() {
    window.revokeThumbnailsDataUrls = this.revokeThumbnailsDataUrls;
  }

  componentWillUnmount() {
    this.revokeThumbnailsDataUrls();
  }

  revokeThumbnailsDataUrls = () => {
    const { monitorings } = this.state;
    Object.values(monitorings).forEach((monitoring) => {
      if (monitoring.data) {
        Object.values(monitoring.data.events).forEach((event) => {
          if (event.thumbnailSrc) {
            URL.revokeObjectURL(event.thumbnailSrc);
          }
          if (event.mediaDataUrl) {
            URL.revokeObjectURL(event.mediaDataUrl);
          }
        });
      }
    });
  };

  setFlowState = (update, callback) => this.setState(update, callback);

  render() {
    const { onClose } = this.props;

    return (
      <Flow
        flowState={this.state}
        setFlowState={this.setFlowState}
        steps={steps}
        onClose={onClose}
      />
    );
  }
}

export default function ({ isOpen, onClose, ...rest }) {
  return (
    <PopoverView
      isOpen={isOpen}
      fluid={true}
      onClose={onClose}
      modalProps={{
        closeOnEsc: true,
        closeOnOverlayClick: false,
        autoFocus: true
      }}
    >
      <HistoryActivityLogFlow {...rest} onClose={onClose} />
    </PopoverView>
  );
}
